import React from 'react'

import { MyFormValues } from 'partials/EditProfileForm'
import { AvatarForm } from 'partials/OnBoarding/subcomponents/subforms/AvatarForm'
import { CityStateForm } from 'partials/OnBoarding/subcomponents/subforms/CityStateForm'
import { FirstAndLastNameForm } from 'partials/OnBoarding/subcomponents/subforms/FirstAndLastNameForm'
import { UserBioForm } from 'partials/OnBoarding/subcomponents/subforms/UserBioForm'
import { UsernameForm } from 'partials/OnBoarding/subcomponents/subforms/UsernameForm'

import { Box } from 'widgets/Box'
import { Button } from 'widgets/Button'

type OnBoardingFormProps = {
  pageIndex: number
  initialValues?: MyFormValues
  onSubmit: (values: any) => void
  saveData: (values: any) => void
  onBack: () => void
  onSkip: () => void
}

export const OnBoardingForm = ({
  pageIndex,
  initialValues = {
    firstName: '',
    lastName: '',
    username: '',
    address: '',
    city: '',
    state: '',
    zipcode: '',
    phone: '',
    bio: '',
  },
  onSubmit,
  saveData,
  onBack,
  onSkip,
}: OnBoardingFormProps) => {
  const renderForm = (): JSX.Element => {
    switch (pageIndex) {
      case 1:
        return <FirstAndLastNameForm initialValues={initialValues} onSubmit={saveData} />
      case 2:
        return <UsernameForm initialValues={initialValues} onSubmit={saveData} />
      case 3:
        return <UserBioForm initialValues={initialValues} onSubmit={saveData} />
      case 4:
        return <CityStateForm initialValues={initialValues} onSubmit={saveData} />
      case 5:
        return <AvatarForm onFinish={() => onSubmit(initialValues)} />
      default:
        return <></>
    }
  }

  return (
    <>
      <Box zIndex={99}>{renderForm()}</Box>

      <Box // Buttons
        margin={{ top: 'sm', horizontal: 'md' }}
      >
        <Box flexDirection='row' margin={{ bottom: 'smd' }} justifyContent='space-around'>
          <Button flex={1} onPress={onBack} title='Back' type='transparent' titleColor='greyDark' />
          {pageIndex >= 3 && (
            <Button
              flex={1}
              onPress={onSkip}
              title='Skip'
              type='transparent'
              titleColor='greyDark'
            />
          )}
        </Box>
      </Box>
    </>
  )
}
